<template>
    <div class="d-flex flex-wrap flex-stack my-5">
        <router-link to="/ecommerce/order" class="btn btn-primary align-self-center">
            <span class="svg-icon svg-icon-2">
                <inline-svg src="/media/icons/duotune/arrows/arr021.svg"/>
            </span>
            {{ $t("pages.ecommerce.order.title") }}
        </router-link>
    </div>
    <div class="d-flex flex-column flex-lg-row" v-if="Object.keys(order).length">
        <div class="flex-lg-row-fluid me-lg-15 order-2 order-lg-1 mb-10 mb-lg-0">
            <div class="card card-flush pt-3 mb-5 mb-xl-10">
                <div class="card-header">
                    <div class="card-title">
                        <h2 class="fw-bolder">{{ $t('pages.ecommerce.order.detail.orderDetails') }}</h2>
                    </div>
                </div>

                <div class="card-body pt-3">
                    <div class="mb-10">
                        <h5 class="mb-4">{{ $t('pages.ecommerce.order.detail.course.title') }}</h5>
                        <div class="table-responsive">
                            <table class="table align-middle table-row-dashed fs-6 gy-4 mb-0">
                                <thead>
                                <tr class="border-bottom border-gray-200 text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                                    <th class="min-w-150px">{{ $t('pages.ecommerce.order.detail.course.cols.name') }}</th>
                                    <th class="min-w-125px">{{ $t('pages.ecommerce.order.detail.course.cols.schedule') }}</th>
                                    <th class="">{{ $t('pages.ecommerce.order.detail.course.cols.quantity') }}</th>
                                    <th class="min-w-125px">{{ $t('pages.ecommerce.order.detail.course.cols.price') }}</th>
                                </tr>
                                </thead>
                                <tbody class="fw-bold text-gray-600">
                                    <TreeCourse
                                        v-for="(course, courseIndex) in order.items"
                                        :item="course"
                                        :itemIndex="courseIndex"
                                        :key="courseIndex"
                                        :showRow="true"
                                        :depth="0"
                                        :currency="$root.defaultCurrency">
                                    </TreeCourse>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="mb-0">
                        <div class="d-flex justify-content-center justify-content-sm-end py-5">
                            <div class="summary-table">
                                <table class="table fs-6 fw-bold gy-4 gx-5 m-0 w-sm-350px">
                                    <tr>
                                        <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.summary.subTotal') }}</td>
                                        <td>:</td>
                                        <td class="text-gray-800 text-end">{{ order.subtotal + ' ' + $root.defaultCurrency.suffix }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.summary.tax') }}</td>
                                        <td>:</td>
                                        <td class="text-gray-800 text-end">{{ order.tax + ' ' + $root.defaultCurrency.suffix }}</td>
                                    </tr>
                                    <!--<tr v-if="order.payment_detail && order.payment_detail.installment_commission">
                                        <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.summary.installmentCommission') }}</td>
                                        <td>:</td>
                                        <td class="text-gray-800 text-end">{{ order.payment_detail.installment_commission + ' ' + order.currency.suffix }}</td>
                                    </tr>-->
                                    <tr>
                                        <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.summary.total') }}</td>
                                        <td>:</td>
                                        <td class="text-gray-800 text-end">{{ order.total + ' ' + $root.defaultCurrency.suffix }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex-column flex-lg-row-auto w-100 w-lg-250px w-xl-300px mb-10 order-1 order-lg-2">
            <div class="card card-flush pt-3 mb-5 mb-lg-10">
                <div class="card-header">
                    <div class="card-title">
                        <h2>{{ $t('pages.ecommerce.order.detail.orderAndPayment.title') }}</h2>
                    </div>
                </div>

                <div class="card-body pt-0 fs-6">
                    <div class="mb-7">
                        <h5 class="mb-3">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.orderNumber') }}</h5>

                        <div class="mb-0">
                            <span class="fw-bold text-gray-600">{{ order.id }}</span>
                        </div>
                    </div>

                    <div class="separator separator-dashed mb-7"></div>

                    <div class="mb-10">
                        <h5 class="mb-3">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.orderDate') }}</h5>

                        <div class="mb-0">
                            <span class="fw-bold text-gray-600">{{ $moment(order.created_at).format("DD.MM.YYYY - HH:mm:ss") }}</span>
                        </div>
                    </div>

                    <div class="separator separator-dashed mb-7"></div>

                    <div class="mb-4">
                        <h5 class="mb-3">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.orderStatus') }}</h5>

                        <div class="mb-0">
                            <div class="d-flex align-items-center mb-1 justify-content-between">
                                <span :class="status[order.status.code.toLocaleLowerCase()] ? status[order.status.code.toLocaleLowerCase()].badge : 'badge-warning'" class="fw-bold badge">{{ order.status.name }}</span>

                                <!--<a v-on:click="changeOrderStatus" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                                    <span class="svg-icon svg-icon-3">
                                        <inline-svg src="/media/icons/duotune/art/art005.svg"/>
                                    </span>
                                </a>-->
                            </div>
                        </div>
                    </div>
                    <!--<template v-if="order.payment_detail">
                        <div class="separator separator-dashed mb-7"></div>

                        <div class="mb-10">
                            <h5 class="mb-3">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.payment.title') }}</h5>

                            <table class="table fs-6 fw-bold gs-0 gy-2 gx-2">
                                <tr class="">
                                    <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.payment.cols.method') }}:</td>
                                    <td class="text-gray-800">{{ order.payment_detail.payment_method.name }}</td>
                                </tr>
                                <tr class="">
                                    <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.payment.cols.paidTotal') }}:</td>
                                    <td class="text-gray-800">{{ order.payment_detail.paid_total + ' ' + order.currency.suffix }}</td>
                                </tr>
                                <tr class="" v-if="order.payment_detail && order.payment_detail.payment_method && order.payment_detail.payment_method.type_id == 2">
                                    <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.payment.cols.remainingCollectAmount') }}:</td>
                                    <td class="text-gray-800">{{ order.payment_detail.remaining_collect_amount + ' ' + order.currency.suffix }}</td>
                                </tr>
                                <tr class="" v-if="order.payment_detail.installment != null">
                                    <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.payment.cols.installment') }}:</td>
                                    <td class="text-gray-800">{{ order.payment_detail.installment == 0 ? $t('common.cash') : order.payment_detail.installment }}</td>
                                </tr>
                                <tr class="" v-if="order.payment_detail.installment_commission">
                                    <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.payment.cols.installmentCommission') }}:</td>
                                    <td class="text-gray-800">{{ order.payment_detail.installment_commission + ' ' + order.currency.suffix }}</td>
                                </tr>
                                !--<template v-if="order.payment_detail.payment_sub_method">
                                    <tr class="">
                                        <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.payment.cols.subMethod.cols.name') }}:</td>
                                        <td class="text-gray-800">{{ order.payment_detail.payment_sub_method.payload.name }}</td>
                                    </tr>
                                    <tr class="">
                                        <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.payment.cols.subMethod.cols.accountNumber') }}:</td>
                                        <td class="text-gray-800">{{ order.payment_detail.payment_sub_method.payload.account_number }}</td>
                                    </tr>
                                </template>
                                <template v-if="order.payment_detail.payment_detail">
                                    <tr class="">
                                        <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.payment.cols.paymentDetail.bank') }}:</td>
                                        <td class="text-gray-800">{{ order.payment_detail.payment_detail.bank_name }}</td>
                                    </tr>
                                    <template v-if="order.payment_detail.payment_detail.credit_card">
                                        <tr class="">
                                            <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.payment.cols.paymentDetail.creditCard.owner') }}:</td>
                                            <td class="text-gray-800">{{ order.payment_detail.payment_detail.credit_card.holder_name }}</td>
                                        </tr>
                                        <tr class="">
                                            <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.payment.cols.paymentDetail.creditCard.number') }}:</td>
                                            <td class="text-gray-800">{{ order.payment_detail.payment_detail.credit_card.blurred_card_number }}</td>
                                        </tr>
                                    </template>
                                </template>--
                            </table>
                        </div>
                    </template>

                    <template v-if="order.payment_detail && order.payment_detail.payment_method_detail && order.payment_detail.payment_method_detail.status == 'failed'">
                        <div class="separator separator-dashed mb-7"></div>

                        <div class="mb-10">
                            <h5 class="mb-3">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.paymentMethodDetailFailed') }}</h5>

                            <div class="mb-0">
                                <div class="d-flex align-items-center mb-1 justify-content-between">
                                    <span class="fw-bold text-gray-600">{{ order.payment_detail.payment_method_detail.failed_reason_msg }}</span>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-if="order.shipping_detail">
                        <div class="separator separator-dashed mb-7"></div>

                        <div class="mb-10">
                            <div class="d-flex align-items-center justify-content-between mb-3">
                                <h5 class="mb-0">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.shipping.title') }}</h5>
                                <el-tooltip v-if="[5, 6].includes(order.shipping_detail.shipping_status_id)" :content="$t('pages.ecommerce.order.shipping.detail.title')" placement="top">
                                    <router-link :to="'/ecommerce/order-management/shipping/detail/' + order.id" target="_blank" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                                        <span class="svg-icon svg-icon-3">
                                            <inline-svg src="/media/icons/duotune/general/gen004.svg" />
                                        </span>
                                    </router-link>
                                </el-tooltip>
                            </div>
                            <table class="table fs-6 fw-bold gs-0 gy-2 gx-2">
                                <tr class="">
                                    <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.shipping.cols.name') }}:</td>
                                    <td class="text-gray-800">{{ order.shipping_detail.shipping_method.name }}</td>
                                </tr>
                                <tr class="">
                                    <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.shipping.cols.number') }}:</td>
                                    <td class="text-gray-800">{{ order.shipping_detail.shipping_tracking_number ?? "-" }}</td>
                                </tr>
                                <tr class="" v-if="order.shipping_detail && order.shipping_detail.shipping_total > 0">
                                    <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.orderAndPayment.cols.shipping.cols.price') }}:</td>
                                    <td class="text-gray-800">{{ order.shipping_detail.shipping_total + ' ' + order.currency.suffix }}</td>
                                </tr>
                            </table>
                        </div>
                    </template>-->
                </div>
            </div>
            <div class="card card-flush pt-3 mb-5 mb-lg-10" v-if="order.student">
                <div class="card-header">
                    <div class="card-title">
                        <h2>{{ $t('pages.ecommerce.order.detail.student.title') }}</h2>
                    </div>
                </div>
                <div class="card-body pt-0 fs-6 pb-4">
                    <div class="mb-4">
                        <div class="d-flex align-items-center mb-1">
                            <span class="fw-bolder text-gray-800 text-hover-primary me-2">{{ order.student.full_name }}</span>
                            <span :class="order.student.active ? 'badge-light-success': 'badge-light-danger'" class="badge">{{ order.student.active ? $t('common.active') : $t('common.passive') }}</span>
                        </div>
                        <table class="table fs-6 fw-bold gs-0 gy-2 gx-2 mt-3">
                            <tr class="">
                                <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.student.cols.mobilePhone') }}:</td>
                                <td class="text-gray-800">{{ order.student.blur_format_phone }}</td>
                            </tr>
                        </table>

                    </div>
                    <!--
                    <div class="separator separator-dashed mb-7"></div>

                    <div class="mb-7" v-if="order.address && order.address.invoice_type_id">
                        <h5 class="mb-3">{{ $t('pages.ecommerce.order.detail.student.cols.address.title') }}</h5>

                        <table class="table fs-6 fw-bold gs-0 gy-2 gx-2">
                            <tr class="">
                                <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.student.cols.address.cols.invoiceType') }}:</td>
                                <td class="text-gray-800">{{ getInvoiceTypeText(order.address.invoice_type_id) }}</td>
                            </tr>
                            <tr class="">
                                <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.student.cols.address.cols.name') }}:</td>
                                <td class="text-gray-800">{{ order.address.firstname + ' ' + order.address.lastname }}</td>
                            </tr>
                            <tr class="">
                                <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.student.cols.address.cols.identificationNumber') }}:</td>
                                <td class="text-gray-800">{{ order.address.identification_number ?? "-" }}</td>
                            </tr>
                            <tr class="">
                                <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.student.cols.address.cols.address') }}:</td>
                                <td class="text-gray-800">{{ order.address.address }}</td>
                            </tr>
                            <tr class="">
                                <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.student.cols.address.cols.neighbourhood') }}:</td>
                                <td class="text-gray-800">{{ (order.address.neighbourhood && order.address.neighbourhood.length) ? order.address.neighbourhood : "-" }}</td>
                            </tr>
                            <tr class="">
                                <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.student.cols.address.cols.location') }}:</td>
                                <td class="text-gray-800">{{ getLocation() }}</td>
                            </tr>
                            <tr class="">
                                <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.student.cols.address.cols.zipCode') }}:</td>
                                <td class="text-gray-800">{{ order.address.zip_code }}</td>
                            </tr>
                            <tr class="">
                                <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.student.cols.address.cols.phone') }}:</td>
                                <td class="text-gray-800"><a :href="'tel:'+ order.address.mobile_phone" class="p-0 fw-bold text-gray-600 text-hover-primary">{{ order.address.mobile_phone }}</a></td>
                            </tr>
                            <template v-if="order.address.invoice_type_id == 2">
                                <tr class="">
                                    <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.student.cols.address.cols.companyName') }}:</td>
                                    <td class="text-gray-800">{{ order.address.company_name }}</td>
                                </tr>
                                <tr class="">
                                    <td class="text-gray-400">{{ $t('pages.ecommerce.order.detail.student.cols.address.cols.companyTaxOffice') }}:</td>
                                    <td class="text-gray-800">{{ order.address.company_tax_office }}</td>
                                </tr>
                            </template>
                        </table>
                    </div>-->
                </div>
            </div>
        </div>
    </div>
    <!--<div class="modal fade" id="kt_modal_change_order" ref="updateOrderModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="fw-bolder">{{ form.title }}</h2>
                    <div id="kt_modal_change_order_close" data-bs-dismiss="modal" class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg"/>
                        </span>
                    </div>
                </div>
                <el-form @submit.prevent="onSubmit()" :model="form.data" ref="orderForm">
                    <div class="modal-body py-10 px-lg-17">
                        <div class="scroll-y me-n7 pe-7" id="kt_modal_change_order_scroll" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_add_customer_header" data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">
                            <div class="fv-row mb-1">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.order.cols.orderStatus') }}</label>
                                <el-form-item prop="status_id" :rules="$validation.getMessage(['required'])">
                                    <el-select v-model="form.data.status_id" class="w-100" :placeholder="$t('common.chooseSelect')">
                                        <el-option v-for="(status, statusIndex) in orderStatus" :key="statusIndex" :value="status.id" :label="status.name"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer flex-center">
                        <button :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary" type="submit" :disabled="form.loading">
                            <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                            <span v-if="form.loading" class="indicator-progress">
                                {{ $t("messages.wait") }}
                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
    <div class="modal fade" id="kt_modal_add_order_note" ref="addOrderNoteModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="fw-bolder">{{ orderNote.form.title }}</h2>
                    <div id="kt_modal_add_customer_close" data-bs-dismiss="modal" class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg"/>
                        </span>
                    </div>
                </div>
                <el-form @submit.prevent="onSubmitOrderNote()" :model="orderNote.form.data" ref="orderNoteForm">
                    <div class="modal-body py-10 px-lg-17">
                        <div class="scroll-y me-n7 pe-7" id="kt_modal_add_customer_scroll" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_add_customer_header" data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">
                            <div class="fv-row mb-1">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.order.note.cols.note') }}</label>
                                <el-form-item prop="note" :rules="$validation.getMessage(['required'])">
                                    <el-input v-model="orderNote.form.data.note" type="textarea" rows="5"/>
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer flex-center">
                        <button :data-kt-indicator="orderNote.form.loading ? 'on' : null" class="btn btn-lg btn-primary" type="submit" :disabled="orderNote.form.loading">
                            <span v-if="!orderNote.form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                            <span v-if="orderNote.form.loading" class="indicator-progress">
                                {{ $t("messages.wait") }}
                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
    <div class="modal fade" id="kt_modal_add_order_payment_collection" ref="addOrderPaymentCollectionModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="fw-bolder">{{ orderPaymentCollection.form.title }}</h2>
                    <div id="kt_modal_order_payment_collection_close" data-bs-dismiss="modal" class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg"/>
                        </span>
                    </div>
                </div>
                <el-form @submit.prevent="onSubmitOrderPaymentCollection()" :model="orderPaymentCollection.form.data" ref="orderPaymentCollectionForm">
                    <div class="modal-body py-10 px-lg-17">
                        <div class="scroll-y me-n7 pe-7" id="kt_modal_order_payment_collection_scroll" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_add_customer_header" data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">
                            <div class="d-flex flex-stack mb-6" v-if="Object.keys(order).length && order.payment_detail">

                                <div class="me-5">
                                    <label class="fs-6 fw-bold mb-1">{{ $t('pages.ecommerce.order.paymentCollection.totalAmount') }}</label>
                                    <div class="fs-7 fw-bold text-gray-400">{{ getOrderSummaryTotal() + ' ' + order.currency.suffix }}</div>
                                </div>

                                <div class="me-5">
                                    <label class="fs-6 fw-bold mb-1">{{ $t('pages.ecommerce.order.paymentCollection.remainingTotal') }}</label>
                                    <div class="fs-7 fw-bold text-gray-400">{{ order.payment_detail.remaining_collect_amount + ' ' + order.currency.suffix }}</div>
                                </div>
                            </div>

                            <div class="fv-row mb-7">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.order.paymentCollection.cols.amount') }}</label>
                                <div class="d-sm-flex">
                                    <el-form-item class="mb-0" prop="amount" :rules="$validation.getMessage(['required'])">
                                        <el-input v-model="orderPaymentCollection.form.data.amount" oninput="value=value.replace(/[^0-9.]/g,'')"/>
                                    </el-form-item>
                                    <button type="button" class="btn btn-sm btn-danger align-self-center ms-sm-5 mt-4 mt-sm-0" v-on:click="transferRemainingAmount()">
                                        <span class="svg-icon svg-icon-1">
                                            <inline-svg src="/media/icons/duotune/arrows/arr060.svg" />
                                        </span>
                                        {{ $t('pages.ecommerce.order.paymentCollection.transferRemainingAmount') }}
                                    </button>
                                </div>
                            </div>

                            <div class="fv-row mb-1">
                                <label class="fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.order.paymentCollection.cols.note') }}</label>
                                <el-form-item prop="note">
                                    <el-input v-model="orderPaymentCollection.form.data.note" type="textarea" rows="5"/>
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer flex-center">
                        <button :data-kt-indicator="orderPaymentCollection.form.loading ? 'on' : null" class="btn btn-lg btn-primary" type="submit" :disabled="orderPaymentCollection.form.loading">
                            <span v-if="!orderPaymentCollection.form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                            <span v-if="orderPaymentCollection.form.loading" class="indicator-progress">
                                {{ $t("messages.wait") }}
                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>-->
</template>

<script>
import CustomTable from "@/components/custom-table";
import TreeCourse from '@/components/ecommerce/order/detail/treeCourse.vue';

export default {
    name: "_id",
    components: {
        CustomTable,
        TreeCourse
    },
    data() {
        return {
            status: {
                pending_payment: {
                    code: 'pendingPayment',
                    badge: 'badge-primary'
                },
                pending: {
                    code: 'pending',
                    badge: 'badge-primary'
                },
                processing: {
                    code: 'processing',
                    badge: 'badge-warning'
                },
                shipped: {
                    code: 'shipped',
                    badge: 'badge-info'
                },
                complete: {
                    code: 'complete',
                    badge: 'badge-success'
                },
                returned: {
                    code: 'returned',
                    badge: 'badge-success'
                },
                cancelled: {
                    code: 'cancelled',
                    badge: 'badge-danger'
                },
                payment_error: {
                    code: 'paymentError',
                    badge: 'badge-danger'
                }
            }
        }
    },
    computed: {
        orderID() {
            return this.$route.params.id;
        },
        order() {
            let order = {};

            let orders = this.$store.state.ecommerce.order.table.data;
            if(orders.length == 1){
                order = orders[0];
            }

            return order;
        },
        orderStatus() {
            return this.$store.state.ecommerce.order.status.table.data;
        },
    },
    created() {
        if (this.orderID && !(this.orderID > 0)) {
            this.$router.push({
                path: "/ecommerce/order"
            });
        }
    },
    mounted() {
        if (this.orderID && this.orderID > 0) {
            this.$store.dispatch('ecommerce/order/get', {
                page: {},
                filterData: {
                    id: this.orderID
                }
            });
            this.$store.dispatch('ecommerce/order/status/get', {});
        }
    },
    methods: {}
}
</script>

<style>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}

.summary-table {
    border: 1px solid #E4E6EF;
    border-radius: 4px;
}

.summary-table .table tr > td {
    border-top: 1px solid #EFF2F5;
}

.summary-table tr:first-child td {
    border-top: none;
}

</style>